var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.5 0.895431 1.39543 0 2.5 0H14.5C15.6046 0 16.5 0.89543 16.5 2V10C16.5 11.1046 15.6046 12 14.5 12H2.5C1.39543 12 0.5 11.1046 0.5 10V2ZM2.5 1C1.94772 1 1.5 1.44772 1.5 2V2.2169L8.5 6.4169L15.5 2.2169V2C15.5 1.44772 15.0523 1 14.5 1H2.5ZM15.5 3.3831L8.5 7.5831L1.5 3.3831L1.53376 10.2586C1.64774 10.6855 2.03715 11 2.5 11H14.5C14.9628 11 15.3523 10.6855 15.4662 10.2586L15.5 3.3831Z",
    fill: "#87898C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotMailIcon);
export default __webpack_public_path__ + "static/media/forgotMailIcon.d628768a438cc836fe57e03c16746566.svg";
export { ForwardRef as ReactComponent };